module.exports = __webpack_public_path__ + "img/CM0010_bear.6732043a.png";